import UAParser from 'ua-parser-js';
import queryString from 'query-string';

/**
 * Manages the source of the meta data that is used for the ad library
 */

// TODO: Potentially make this dynamic, so any changes are reflected immediately

export function getDeviceMeta() {
  const { device, os, ua, browser } = new UAParser().getResult();
  const orientation = (window.innerHeight > window.innerWidth) ? 'portrait' : 'landscape';

  return {
    ...device,
    type: device.type || 'desktop',
    orientation,
    os,
    ua,
    browser,
  };
}

export function getLocationMeta() {
  const { host, hostname, href, origin, pathname, protocol, search } = window.location;
  const query = queryString.parse(search);

  return {
    host,
    hostname,
    href,
    origin,
    pathname,
    protocol,
    search,
    query,
  };
}

export function getEnvMeta() {
  return buildEnv;
}

export default class SourceOfTruth {
  isReady = false;

  ready;

  _meta = {
    page: {},
    device: {},
    location: {},
  };

  _pageMetaFn;

  constructor(pageMetaFn) {
    this.updatePageMetaFunction = this.updatePageMetaFunction.bind(this);
    this.refresh = this.refresh.bind(this);
    this.initialize = this.initialize.bind(this);

    this._pageMetaFn = pageMetaFn;

    this.ready = this.initialize();
  }

  updatePageMetaFunction(pageMetaFn) {
    this._pageMetaFn = pageMetaFn;
  }

  refresh() {
    this._meta.page = {};
    this._meta.device = {};
    this._meta.location = {};
    this._meta.env = {};

    this.isReady = false;
    this.ready = this.initialize();

    return this.ready;
  }

  get meta() {
    return this._meta;
  }

  get env() {
    return this._meta.env;
  }

  get page() {
    return this._meta.page;
  }

  get device() {
    return this._meta.device;
  }

  get location() {
    return this._meta.location;
  }

  initialize() {
    const metaProviders = [
      this._pageMetaFn,
      getDeviceMeta,
      getLocationMeta,
      getEnvMeta,
    ];

    return Promise.all(metaProviders.map(func => func()))
      .then(([page, device, location, env]) => {
        Object.assign(this._meta, { page, device, location, env });
        this.isReady = true;
        return this;
      });
  }
}
